import { memo } from 'react';

import classes from './MLOCheckboxInfoText.module.scss';

interface MLOCheckboxInfoTextProps {
  clientSupportsMlo?: boolean;
}

const MLOCheckboxInfoText = (props: MLOCheckboxInfoTextProps) => {
  const { clientSupportsMlo } = props;

  return (
    <>
      {!clientSupportsMlo && (
        <div className={classes.notSupported}>The selected client device does not support this feature.</div>
      )}
      <div>
        Multi-Link Operation (MLO), a feature that increases capacity by simultaneously sending and receiving data
        across different frequency bands and channels. (2.4 GHz, 5 GHz, 6 GHz).
      </div>
    </>
  );
};

const MemoizedMLOCheckboxInfoText = memo(MLOCheckboxInfoText);

export default MemoizedMLOCheckboxInfoText;
